import { z } from '@hono/zod-openapi';

export const VehicleCategorySchema = z
  .object({
    id: z.string().openapi({
      example: 'vc_abc123xyz',
      description: 'Vehicle category ID',
    }),
    code: z.string().openapi({
      example: 'M1',
      description: 'Short code identifying the category (e.g. M1, N1, L3)',
    }),
    name: z.string().openapi({
      example: 'Sõiduautod',
      description: 'Human-readable display name shown in the admin UI',
    }),
    createdAt: z.date().or(z.string()),
    updatedAt: z.date().or(z.string()),
    deletedAt: z.date().or(z.string()).nullable().optional().openapi({
      description: 'Soft-delete timestamp; null/omitted when active. Admin list only returns active categories.',
    }),
  })
  .openapi('VehicleCategory');

export const VehicleCategoryCreateSchema = z
  .object({
    code: z.string().min(1).openapi({
      example: 'M1',
      description: 'Short code identifying the category (unique)',
    }),
    name: z.string().min(1).openapi({
      example: 'Sõiduautod',
      description: 'Human-readable display name',
    }),
  })
  .openapi('VehicleCategoryCreate');

export const VehicleCategoryUpdateSchema = z
  .object({
    code: z.string().min(1).openapi({
      example: 'M1',
      description: 'Short code identifying the category (unique)',
    }),
    name: z.string().min(1).openapi({
      example: 'Sõiduautod',
      description: 'Human-readable display name',
    }),
  })
  .openapi('VehicleCategoryUpdate');

export const VehicleCategoryIdParamSchema = z.object({
  id: z.string().openapi({
    param: { name: 'id', in: 'path' },
    example: 'vc_abc123xyz',
    description: 'Vehicle category ID',
  }),
});

export type VehicleCategory = z.infer<typeof VehicleCategorySchema>;
export type VehicleCategoryCreate = z.infer<typeof VehicleCategoryCreateSchema>;
export type VehicleCategoryUpdate = z.infer<typeof VehicleCategoryUpdateSchema>;
